import script from "./R2BDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./R2BDetails.vue?vue&type=script&setup=true&lang=js"

import "./R2BDetails.vue?vue&type=style&index=0&id=5de6b8f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de6b8f5"]])

export default __exports__